<div class="e-sorting-and-summary">
    <ng-container *ngIf="!isLoading && searchTerm.length !== 0">
        <button
            class="e-search-summary-button"
            [disabled]="disableOptions"
            aria-label="Open a summary of your current search criteria and filter selection"
            (click)="showSearchAndFilterSummary()">
            <i class="far fa-clipboard-list"></i>
            <span>Search and Filter Summary</span>
        </button>

        <br />
        <ng-container *ngIf="!isFilterSelected; then withOutFilter; else withFilter"></ng-container>
        <ng-template #withOutFilter>
            <p class="e-search-summary">
                We've found <strong>{{ skuCount.toString() }} SKUs</strong> which match
                <strong>"{{ searchTerm }}" <i>in</i> {{ searchOption.searchDimension }}</strong>
            </p>
        </ng-template>
        <ng-template #withFilter>
            <p class="e-search-summary">
                We've found <strong>{{ skuCount.toString() }} SKUs</strong> which match
                <strong>"{{ searchTerm }}" <i>in</i> {{ searchOption.searchDimension }} <i>+</i> Filters</strong>
            </p>
        </ng-template>
    </ng-container>

    <div class="e-sorting-options-container" *ngIf="!disableOptions">
        <strong>Sort By</strong>
        <mat-form-field appearance="fill" class="e-sort-by-select">
            <mat-select
                name="sortOpt"
                (selectionChange)="onSortByChange()"
                [(ngModel)]="selectedSortOption"
                panelClass="e-mat-select-panel">
                <mat-option *ngFor="let option of sortOptions" [value]="option.value">
                    {{ option.label }}
                </mat-option>
            </mat-select>
        </mat-form-field>

        <via-info-icon class="e-sort-by-tooltip" [tooltipText]="sortByTooltip"></via-info-icon>

        <button class="e-sort-order-button" [class.e-ascending]="selectedOrder === 'ascending'" (click)="toggleSortOrder()">Order</button>

        <strong>Currency</strong>
        <via-ui-currency-dropdown
            [selectedCurrency]="selectedCurrency"
            (currencyChange)="updateCurrency($event)"></via-ui-currency-dropdown>
    </div>
</div>
